export default __webpack_public_path__ + "static/media/tfg-title-en.cdc80e50.webp";